import React, { useState } from 'react';
import { Dialog, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import close from '../../../../assets/icons/close.svg';
import AutomService from '../../../../services/AutomService/AutomService';

function ChooseAutom(props) {
    const { t } = useTranslation();
    const [state, setState] = useState([]);
    const handleClose = () => { props.setOpen(false); };
    const handleChange = (e) => {
        let name = e.target.name;
        let checked = e.target.checked;
        let id = props.data[name].id
        props.data[name].checked = checked;
        if (checked) { setState([...state, id]); }
        else { setState(state.filter(x => x !== id)); }
    }
    const handleClick = async () => {
        let ids = [];
        for (const item of props.data) {
            if (!state.includes(item.id)) { ids.push(item.id); }
        }
        const res = await AutomService.changeAutomsStatus({status: false, ids});
        if (res?.status) { props.setOpen(false); props.setRefresh(x => !x); }
    }
    const getStyle = (e) => { return e ? {opacity: 1, backgroundColor: '#fff'} : null; }
    return (
        <Dialog open={true} onClose={handleClose}>
            <div style={{padding: 25}}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div className="alert alert-danger">
                        <div>{t('CONTENT.CREDENTIAL-TAB.LOCALE') === 'tr-TR' ?
                            <span>Bir lisans ihlali tespit edildi. Aktif lisans bilgileriyle devam etmek için lütfen <strong>{props.count} Autom</strong> seçin.</span>:
                            <span>A license violation has been detected. Please choose <strong>{props.count} of Autom(s)</strong> to continue with the active license information.</span>}
                        </div>
                        <img src={close} onClick={handleClose} alt="close-icon" style={{cursor: 'pointer'}}/>
                    </div>
                </div>
                <div>
                    {props.data.map((item, itemI) => {
                        return (
                            <div key={itemI} style={{borderRadius: '2px 10px 10px 2px', borderLeft: '5px solid #031226', marginTop: 20}}>
                                <input type="checkbox" onChange={handleChange} style={{display: 'none'}}
                                    id={'choose-bot' + itemI} name={itemI} checked={item.checked?item.checked:false}/>
                                <label className="customize-view-group-1" htmlFor={'choose-bot' + itemI}
                                    style={{padding: 10, cursor: 'pointer', opacity: 0.7, backgroundColor: '#eee', ...getStyle(item.checked)}}
                                >
                                    <span className="customize-view-col-name">{item.name}</span>
                                </label>
                            </div>
                        )
                    })}
                </div>
                <div style={{textAlign: 'center', marginTop: 20}}>
                    <Button variant="outlined" style={{backgroundColor: "#031226"}} onClick={handleClick}>
                        <span className="customize-view-col-name" style={{color: '#fff', marginLeft: 0}}>{t('CONTENT.AUTOMS-LIST.APPLY')}</span>
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}

export default ChooseAutom;